import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

import { ref, toRefs, reactive } from "vue";
import dayjs, { Dayjs } from "dayjs";
import type { Rule } from "ant-design-vue/es/form";
import moment from "moment";
import { FormInstance, message } from "ant-design-vue";
import { addPos } from "@/api/pos";
const dateFormat = "YYYY-MM-DD";
interface FormData {
  employeeName: string;
  employeeJobNumber: string;
  branchId: string;
  email: string;
  employeeIdNum: string;
  insuredBirth: Dayjs | string;
  insuredGender: string;
  insuredIdType: string;
  insuredIdNum: string;
  insuredName: string;
  phone: string;
  planPackageId: string;
  relation: string;
  socialSecurityArea: string;
  startTime: string;
  workPlace?: string;
  affiliation?: string;
  bankBranch?: string;
  wage?: string;
  accident?: string;
  occCate?: string;
  death?: string;
  customAccident?: string;
  customDeath?: string;
  customSeriousIllness?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AddPosModal',
  props: {
  idTypeDicList: Array,
  planPackageDicList: Array,
  genderDicList: Array,
  bankDicList: Array,
  branchDicList: Array,
  relationDicList: Array,
  simple: Array,
},
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: __emit }) {

const open = ref<boolean>(false);
const emits = __emit;
const isSelfRelaiton = ref(true);
const props = __props;
const {
  idTypeDicList,
  planPackageDicList,
  genderDicList,
  bankDicList,
  branchDicList,
  relationDicList,
  simple,
} = toRefs(props);

const formRef = ref<FormInstance>();
const formdata = reactive<FormData>({
  employeeName: "",
  employeeJobNumber: "",
  branchId: "",
  email: "",
  employeeIdNum: "",
  insuredBirth: "",
  insuredGender: "",
  insuredIdType: "",
  insuredIdNum: "",
  insuredName: "",
  phone: "",
  planPackageId: "",
  relation: "",
  socialSecurityArea: "",
  startTime: "",
  workPlace: "",
  affiliation: "",
  bankBranch: "",
  wage: "",
  accident: "",
  occCate: "",
  death: "",
  customAccident: "",
  customDeath: "",
  customSeriousIllness: "",
});
const rules: Record<string, Rule[]> = {
  employeeName: [{ required: true, message: "请输入员工姓名" }],
  employeeJobNumber: [{}],
  branchId: [{ required: true, message: "请选择分支机构" }],
  email: [{}],
  employeeIdNum: [{ required: true, message: "请输入员工证件号" }],
  insuredBirth: [{ required: true, message: "请选择被保险人出生日期" }],
  insuredGender: [{ required: true, message: "请选择被保险人性别" }],
  insuredIdNum: [{ required: true, message: "请输入被保险人证件号" }],
  insuredIdType: [{ required: true, message: "请选择被保险人证件类型" }],
  insuredName: [{ required: true, message: "请输入被保险人姓名" }],
  phone: [{}],
  planPackageId: [{ required: true, message: "请选择保险计划" }],
  relation: [{ required: true, message: "请选择被保险人与员工关系" }],
  socialSecurityArea: [{}],
  startTime: [{ required: true, message: "请选择被保险人生效日期" }],
};
const birthDate = ref<Dayjs>();
const startDate = ref<Dayjs>();
const showModal = () => {
  open.value = true;
};

const handleSubmit = (values: any) => {
  values.insuredBirth = dayjs(values.insuredBirth).format("YYYY-MM-DD");
  values.startTime = dayjs(values.startTime).format("YYYY-MM-DD");
  addPos(values)
    .then((res: any) => {
      if (res.code == 200 && res.data.batchNumber) {
        message.success("添加成功");
        emits("refresh");
        for (let key in formdata) {
          (formdata as any)[key] = null;
        }
        open.value = false;
      } else {
        message.error(res.msg);
      }
    })
    .catch();
};

const handleChangeRelation = (data: any) => {
  if (data == "SELF") {
    isSelfRelaiton.value = false;
  } else {
    isSelfRelaiton.value = true;
  }
};
const handleFinshIdNum = (value: any) => {
  if (formdata.insuredIdType == "ID_CARD" && formdata.insuredIdNum != "") {
    let res = parseIDCard(formdata.insuredIdNum);
    formdata.insuredGender = res.gender;
    formdata.insuredBirth = dayjs(res.birthDate);
  }
};
const handleFinishFailed = (errors: any) => {
  console.log(
    "%c [ errors ]-188",
    "font-size:13px; background:pink; color:#bf2c9f;",
    errors
  );
};
__expose({
  showModal,
});

function parseIDCard(id: string): {
  gender: "Male" | "Female";
  birthDate: Date;
} {
  if (id.length !== 18) {
    throw new Error("Invalid ID card number. It should be 18 digits long.");
  }

  const genderCode = parseInt(id.charAt(16), 10);
  const gender = genderCode % 2 === 0 ? "FEMALE" : "MALE";

  // 转换为日期对象，注意月份是从0开始的，所以需要减1
  const year = parseInt(id.substring(6, 10), 10);
  const month = parseInt(id.substring(10, 12), 10) - 1;
  const day = parseInt(id.substring(12, 14), 10);

  const birthDate = new Date(year, month, day);

  return {
    gender,
    birthDate,
  };
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ((open).value = $event)),
      title: "单人增保",
      width: "600px",
      okText: "取消",
      cancelText: "取消",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, _mergeProps({
          ref_key: "formRef",
          ref: formRef,
          model: formdata,
          style: {"width":"600px","margin":"0 auto"}
        }, {
          labelCol: { span: 7 },
          wrapperCol: { span: 12 },
        }, {
          rules: rules,
          onFinish: handleSubmit,
          onFinishFailed: handleFinishFailed
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              name: "insuredName",
              label: "姓名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formdata.insuredName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formdata.insuredName) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "insuredIdType",
              label: "证件类型"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: formdata.insuredIdType,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formdata.insuredIdType) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(idTypeDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "insuredIdNum",
              label: "证件号"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formdata.insuredIdNum,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formdata.insuredIdNum) = $event)),
                  onBlur: handleFinshIdNum
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "insuredBirth",
              label: "出生日期"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: formdata.insuredBirth,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formdata.insuredBirth) = $event)),
                  placeholder: "请选择出生日期",
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "insuredGender",
              label: "性别"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: formdata.insuredGender,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formdata.insuredGender) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(genderDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "socialSecurityArea",
              label: "社保地"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formdata.socialSecurityArea,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formdata.socialSecurityArea) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "relation",
              label: "人员类别"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: formdata.relation,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formdata.relation) = $event)),
                  onChange: handleChangeRelation
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relationDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            (isSelfRelaiton.value)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  name: "employeeName",
                  label: "员工姓名"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formdata.employeeName,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((formdata.employeeName) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (isSelfRelaiton.value)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  name: "employeeIdNum",
                  label: "员工证件号"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formdata.employeeIdNum,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((formdata.employeeIdNum) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              name: "branchId",
              label: "分公司"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: formdata.branchId,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((formdata.branchId) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(branchDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "phone",
              label: "手机号"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formdata.phone,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((formdata.phone) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "email",
              label: "邮箱"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formdata.email,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((formdata.email) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "employeeJobNumber",
              label: "工号"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formdata.employeeJobNumber,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((formdata.employeeJobNumber) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "planPackageId",
              label: "保障方案"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: formdata.planPackageId,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((formdata.planPackageId) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(planPackageDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "startTime",
              label: "生效日期"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: formdata.startTime,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((formdata.startTime) = $event)),
                  placeholder: "",
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(simple), (item, key) => {
              return (_openBlock(), _createBlock(_component_a_form_item, {
                name: Object.keys(item)[0],
                label: item[Object.keys(item)[0]]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: formdata[Object.keys(item)[0]],
                    "onUpdate:value": ($event: any) => ((formdata[Object.keys(item)[0]]) = $event)
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _: 2
              }, 1032, ["name", "label"]))
            }), 256)),
            _createVNode(_component_a_form_item, { "wrapper-col": { offset: 5, span: 12 } }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit",
                  style: {"width":"300px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})